module.exports = __webpack_public_path__ + "static/img/原料泡泡-3.535e6ff7.png";